import { useNavigate } from "react-router-dom";
import { aboutHero } from "../../assets";
import { Fade } from "react-awesome-reveal";
import { trackEvent } from "../../helpers";
import {
  PageWrapper,
  HeroImageCircle,
  HeroImage,
  HeroButtons,
  PrimaryButton,
  SecondaryButton,
  AboutSection,
  AboutContainer,
  AboutImageWrapper,
  AboutContent,
  AboutTitle,
  AboutSubtitle,
  AboutDescription,
  HeroStatsSection,
  StatItem,
  StatValue,
  StatLabel,
} from "../home/home.styles";
import { Footer } from "../../components/footer";
import { Background } from "../../components/background";
import { TestimonialsScroll } from "../../components/testimonials-scroll";

export const About = () => {
  const navigate = useNavigate();

  const navigateAndTrack = (path: string, event: string) => {
    navigate(path);
    trackEvent(event);
  };

  return (
    <>
      <PageWrapper style={{ height: 'auto', minHeight: '100vh', overflow: 'visible' }}>
        <Background />

      {/* About Me Section */}
      <AboutSection style={{ paddingTop: '100px', paddingBottom: '40px' }}>
        <AboutContainer>
          <AboutImageWrapper>
            <Fade triggerOnce>
              <HeroImageCircle>
                <HeroImage src={aboutHero} alt="Renée-Louise" />
              </HeroImageCircle>
            </Fade>
          </AboutImageWrapper>

          <AboutContent>
            <Fade triggerOnce>
              <AboutTitle>About Me</AboutTitle>
              <AboutSubtitle>Your product vision, backed by sound engineering</AboutSubtitle>
            </Fade>
            <Fade delay={100} triggerOnce>
              <AboutDescription>
                I'm a Full Stack Engineer with over six years of experience building products and implementing AI solutions. I work closely with founders to understand their product vision, capture requirements accurately and find the right technical approach to bring it to life.
              </AboutDescription>
              <AboutDescription>
                My standards have been shaped by engineering programmes sponsored by GCHQ, Goldman Sachs and Monzo. I bring that rigour to every project, alongside genuine care for what you're building and the people it's for.
              </AboutDescription>
            </Fade>
            <Fade delay={150} triggerOnce>
              <HeroButtons>
                <PrimaryButton onClick={() => navigateAndTrack("/contact", "About - Contact click")}>
                  Book a discovery call
                </PrimaryButton>
                <SecondaryButton onClick={() => navigateAndTrack("/services", "About - Services click")}>
                  Explore services
                </SecondaryButton>
              </HeroButtons>
            </Fade>

            {/* Stats Section */}
            <HeroStatsSection style={{ marginTop: '32px' }}>
              <Fade delay={200} triggerOnce>
                <StatItem
                  onClick={() => navigateAndTrack("/about", "About - Experience stat click")}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      navigateAndTrack("/about", "About - Experience stat click");
                    }
                  }}
                  tabIndex={0}
                  role="button"
                  style={{ cursor: 'pointer' }}
                >
                  <StatValue>6 years</StatValue>
                  <StatLabel>BUILDING AI-POWERED SOFTWARE AT SCALE</StatLabel>
                </StatItem>
              </Fade>
              <Fade delay={250} triggerOnce>
                <StatItem
                  onClick={() => {
                    window.open('https://bragbooq.com', '_blank');
                    trackEvent("About - Bragbooq stat click");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      window.open('https://bragbooq.com', '_blank');
                      trackEvent("About - Bragbooq stat click");
                    }
                  }}
                  tabIndex={0}
                  role="button"
                  style={{ cursor: 'pointer' }}
                >
                  <StatValue>Founder</StatValue>
                  <StatLabel>BRAGBOOQ</StatLabel>
                </StatItem>
              </Fade>
              <Fade delay={300} triggerOnce>
                <StatItem>
                  <StatValue>Audits</StatValue>
                  <StatLabel>ARCHITECTURE & DELIVERY REVIEWS</StatLabel>
                </StatItem>
              </Fade>
              <Fade delay={350} triggerOnce>
                <StatItem
                  onClick={() => navigateAndTrack("/the-guide", "About - Author stat click")}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      navigateAndTrack("/the-guide", "About - Author stat click");
                    }
                  }}
                  tabIndex={0}
                  role="button"
                  style={{ cursor: 'pointer' }}
                >
                  <StatValue>Author</StatValue>
                  <StatLabel>THE UNHINGED GUIDE TO BREAKING INTO TECH</StatLabel>
                </StatItem>
              </Fade>
            </HeroStatsSection>
          </AboutContent>
        </AboutContainer>
      </AboutSection>
      </PageWrapper>

      {/* Testimonials Section */}
      <TestimonialsScroll />

      <Footer />
    </>
  );
};
